import round from 'lodash.round';

export const getRoundedInput = (number: number, allowDecimal: boolean) => {
  const roundedNumber = allowDecimal === false ? round(number) : round(number, 1);

  return roundedNumber;
};
